import { render } from "./Gallery.html?vue&type=template&id=51995d94&scoped=true&ts=true&external"
import script from "./Gallery.ts?vue&type=script&lang=ts&external"
export * from "./Gallery.ts?vue&type=script&lang=ts&external"

import "./Gallery.scss?vue&type=style&index=0&id=51995d94&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51995d94"]])

export default __exports__